export const APPOINTMENT_FIELD_GROUP = 'CD2.AppointmentFields';
//export const APPOINTMENT_REASON_FOR_VISIT = `${APPOINTMENT_FIELD_GROUP}.ReasonForVisit`;
export const APPOINTMENT_MANAGED_REFERRING_PROVIDER = `${APPOINTMENT_FIELD_GROUP}.ManagedReferringProvider`;
export const APPOINTMENT_UNMANAGED_REFERRING_PROVIDER = `${APPOINTMENT_FIELD_GROUP}.UnmanagedReferringProvider`;
export const APPOINTMENT_ORG_REFERRING_PROVIDER = `${APPOINTMENT_FIELD_GROUP}.OrganizationReferringProvider`;
export const APPOINTMENT_REQUEST_EARLIER_APPOINTMENT = `${APPOINTMENT_FIELD_GROUP}.RequestEarlierAppointment`;
